/** Only the sale flow mounts for cashiers. API authorization remains authoritative. */
export function cashierPageAllowed(path: string): boolean {
  return /^\/companies\/?$/.test(path) ||
    /^\/companies\/[^/]+\/facturas(?:\/[^/]+(?:\/preview)?)?\/?$/.test(path);
}

/** Account entry is independent of permissions in the currently selected team. */
export function isAccountEntryPath(path: string): boolean {
  return path === "/login" || path === "/auth/callback" || /^\/invite\/(?:accept|decline)\/[^/]+\/?$/.test(path);
}
